const toSafeNumber = (value) => {
  const numeric = Number(value);
  return Number.isFinite(numeric) ? numeric : null;
};

export const formatDuration = (totalSeconds, options = {}) => {
  const {
    invalidLabel = '0s',
    zeroLabel = '0s',
    minuteUnit = 'min',
    shortMinutes = false,
  } = options;

  const value = toSafeNumber(totalSeconds);
  if (value === null) return invalidLabel;

  const seconds = Math.floor(value);
  if (seconds <= 0) return zeroLabel;
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  const minuteSuffix = shortMinutes ? 'm' : minuteUnit;
  if (minutes < 60) return `${minutes}${minuteSuffix}`;

  const hours = Math.floor(minutes / 60);
  const remMinutes = minutes % 60;
  if (hours < 24) {
    return remMinutes ? `${hours}h ${remMinutes}${minuteSuffix}` : `${hours}h`;
  }

  const days = Math.floor(hours / 24);
  const remHours = hours % 24;
  if (days < 7) {
    return remHours ? `${days}d ${remHours}h` : `${days}d`;
  }

  const weeks = Math.floor(days / 7);
  const remDays = days % 7;
  return remDays ? `${weeks}sem ${remDays}d` : `${weeks}sem`;
};
